// jshint esversion: 8

export default {
  data: [],
  length: null,
  completed: null,
  booked: null,
  updated: null
}
